module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_prf_r1"
    }
  }, [_vm._v("IMPORTANT PREFACE TO THE SECOND EDITION")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_ded_r1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_ack_r1"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c01_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER ONE - On the Dancing Death of Amanda Palmer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER TWO - On the Strange Case of the Death of Amanda Palmer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER THREE - One Day Last Week I Met Amanda Palmer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER FOUR - On the Near Perfect Death of Amanda Palmer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER FIVE - On the Unsung Death of Amanda Palmer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER SIX - On the Aesthetic Decline of the Mock-Funeral")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER SEVEN - On the Unreported Death of Amanda Palmer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER EIGHT - On the Exultant Death of Amanda Palmer")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER NINE")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT NUMBER TEN - Upon the Death of Amanda Palmer")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_bm1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ON THE MANY CRIMES OF TOBIAS JAMES")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_ap1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX I - Editor’s Introduction to the Appendices")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_ap2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX II - The Case Against “Tobias James”")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_ap3_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX III - Who Is Tobias James?—a brief biography")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_ap4_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX IV - On the Writing of Tobias James—a Psychological Analysis")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_ap5_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX V - A Brief Comment on the Many Rumours and Speculations Surrounding  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_bm2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POSTSCRIPT")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_ata_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editor")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_bm3_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Rohan Kriwaczek:")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/kriw_9781590206102_oeb_bm4_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recordings by Rohan Kriwaczek")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a075968","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kriw_9781590206102_oeb_toc_r1.vue
// module id = 57
// module chunks = 0